import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "../../framework/helpers/BreakpointHelper/BreakpointHelper";

export const ImagesListWrapper = styled.div.attrs(({}) => ({}))`

    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    row-gap: 3rem;
    column-gap: 2rem;
    flex-wrap: wrap;

    img {
        height: 170px;
        max-width: 100%;
        object-fit: contain;
        width: calc(100% / 4 - (2rem * 3 / 4));
        ${media.lessThan(breakpoints.ipad)`
           width: calc(100% / 3 - (1.5rem * 2 / 3));
        `}
        ${media.lessThan(breakpoints.mobile)`
            width: calc(100% / 2 - (1.5rem * 1 / 2));
            max-height: 170px;
        `}
        ${media.lessThan(breakpoints.small)`
            width: 100%;
        `}
    }

    ${media.lessThan(breakpoints.ipad)`       
        gap: 1.5rem;
    `}
    
    ${media.lessThan(breakpoints.small)`
        flex-direction: column;
    `}

`;
